import type { FaireProductEntity } from "../../entity_types/product";

export const p_sx8txf2x29: FaireProductEntity = {
  token: "p_sx8txf2x29",
  type: "product",
  name: "Everything Hurts And I'm Dying Grip Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/f25b040daca7865a5392f0e5ff7f52241de9fd93f98f4a622f1342fc70c0b2b8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2a7741b18046544d66d9427b7af95999045c9549175cf7a26970b3aa7c42c7a3.jpeg",
    "https://cdn.faire.com/fastly/ea71bb886627f01475bb9c7a88af487603d13e577aa1818c011c9de051c49ca3.jpeg",
    "https://cdn.faire.com/fastly/3a28b577374e3fc9fd4721c050ab4332c3a2654d0225f15e19721eee2eb13ca7.jpeg",
    "https://cdn.faire.com/fastly/af3a66fd0c6131f532f7f302cc6049d61c3b8759be8a73d191e523cf8d6f02d6.jpeg",
    "https://cdn.faire.com/fastly/1831276999d30def9f08983f966d3d4c1e13a05386c92804bbd06609f1e13832.jpeg",
    "https://cdn.faire.com/fastly/84fbc21c1985e3e0551ff5eaa9e0969e3fd9610104529bc1a80279246f455e51.jpeg",
    "https://cdn.faire.com/fastly/747f279a35badc2e11e8a11644ed9851264a0aee95148ef8a966a453f34f313e.jpeg"
  ],
  priceDollars: 9.6,
  description: "These grippy socks are made for anyone who has mastered the delicate art of functioning while absolutely falling apart.\n\nFinally! Grip socks that do a better job and look good doing it. 🤩\n\n• Woven-in premium grip yarn that holds up use after use. No glued-on dots.\n• Knit into the heel and toe, not just the sole, for better stability.\n• Built for Pilates, barre, yoga, and every stretch in between.\n• Bold, funny, and unreasonably well made in the USA!\n\n#pilatessocks #gripsocks #grippysocks #barresocks #yogasocks #grippy #lagreesocks #pilates #barre #lagree #yoga #grip\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:28.618Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
